// extracted by mini-css-extract-plugin
export default {"dataWrapper":"KPI_dataWrapper__TgyA4","dataItem":"KPI_dataItem__LuRJi","change":"KPI_change__LaCSM","wrapper":"KPI_wrapper__-5QKI"};